<h1 mat-dialog-title>{{ 'incidentManagement.dialogs.createNewIncident.title' | t }}</h1>
<mat-dialog-content>
  <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" type="button" mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" (click)="submit()">{{ 'common.save' | t }}</button>
</mat-dialog-actions>
